import { Toaster as Sonner, toast as sonnerToast } from "sonner"

// Custom toast wrapper with navy blue success color
const toast = {
  success: (message) => {
    sonnerToast(message, {
      style: {
        background: '#DBEAFE',
        border: '1px solid #3B82F6',
        color: '#1E3A8A',
      },
      icon: '✓',
    });
  },
  error: (message) => {
    sonnerToast.error(message);
  },
  info: (message) => {
    sonnerToast(message);
  },
  warning: (message) => {
    sonnerToast.warning(message);
  },
};

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      position="top-right"
      toastOptions={{
        unstyled: false,
      }}
      {...props} />
  );
}

export { Toaster, toast }
